import { createTestIds } from "../../util/createTestIds";

const testIds = createTestIds("searchModal", ["container"] as const);

export default testIds;
